import {common_utils} from "../common/common_utils";
import {game_5008} from "./game_5008";
import {slots_tool} from "./slots_tool";
import {game_5014} from "./game_5014";

function game_5010()
{

}

game_5010.odd_map  = {
  "W":[0,0,20,80,600],
  "S":[0,0,5,10,20],
  "P8":[0,0,50,100,300],
  "P7":[0,0,40,80,200],
  "P6":[0,0,30,60,150],
  "P5":[0,0,25,40,60],
  "P4":[0,2,18,25,40],
  "P3":[0,2,15,20,30],
  "P2":[0,1,10,12,15],
  "P1":[0,1,5,8,10],
  // "B":[0,0,15,80,150],
  "J":[0,0,0,0,0],
};
game_5010.mul_array  = [

];

game_5010.mul = 1

game_5010.readDataValue = function(this1,data)
{
    this1.hasfree = true
    this1.hasbonuswin = true
    this1.hasjackpotwin = true
    this1.mapList = []

    var rows = 3
    this1.isfree = common_utils.isFreeTip(data)
    common_utils.readDataValue(this1,data);
    var mapJson = JSON.parse(data.detail.mapData)
    this1.scatterwin = data.detail.winFreeGameTimes

    this1.mapIndex = []
    var mapTmp = []
    for (var j = 0; j < rows; j++)
    {
      for (var i = 0; i < 5; i++) {
        mapTmp.push(mapJson.map[i][j])
      }
    }
    this1.mapList.push(mapTmp)

    var mapIndexTmp = []
    var winListDic = {}
    for (var index = 0; index < mapJson.wins.length; index++)
    {
      var line = true;
      let win_data = mapJson.wins[index]
      for(var subIndex = 0; subIndex < 5; subIndex++)
      {
        var showindex = win_data.l[subIndex] * 5 + subIndex;
        var item = mapTmp[showindex];
        if ((item != mapJson.wins[index].s) && (item != "W"))
        {
          line = false
        }
        if (line)
        {
           mapIndexTmp.push(showindex)
        }

      }
      slots_tool.read_win_data(winListDic,win_data)
    }
    this1.mapListDetail.push(winListDic)
    this1.mapIndex.push(mapIndexTmp)
    this1.bonuswin = mapJson.bonusWin
    this1.jackpotwin = mapJson.jackpotWin
    let lineCount = mapJson.lineCount;
    let winValueList = [];
    slots_tool.setWinValue(winValueList,this1.mapListDetail,game_5010.odd_map,0);
    this1.winValueTotal = slots_tool.TotalValueByData(winValueList,data,lineCount,false,0,this1.bonuswin);

    this1.$nextTick(() => {
      setTimeout(() => {
        this1.clearLines();
        let  key = "0"
        for (var index = 0; index < mapJson.wins.length; index++) {
          for(var subIndex = 0; subIndex < 4; subIndex++) {
            var fromIndex = mapJson.wins[index].l[subIndex] * 5 + subIndex;
            var toIndex = mapJson.wins[index].l[subIndex + 1] * 5 + subIndex + 1;
            // slots_tool.drawLines("m_s"  + key + "_" + fromindex, "m_s"  + key + "_" + toindex, index)
            slots_tool.drawLines(slots_tool.setMapsLineIdName("s",key,fromIndex), slots_tool.setMapsLineIdName("s",key,toIndex), index)
          }
        }
      }, 500);
    })
}
export {
  game_5010
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5010.js